import { Center, Code, Container, Divider, Paper, ScrollAreaAutosize, Stack, Text, Title } from '@mantine/core';
import type { ErrorComponentProps } from '@tanstack/react-router';

export function DefaultError({
  error,
}: ErrorComponentProps<
  Error & {
    fileName?: string;
    lineNumber?: number;
    columnNumber?: number;
  }
>) {
  return (
    <Center style={{ gridArea: '1 / 1 / -1 / -1', placeSelf: 'center' }}>
      <Container m="lg" size="lg">
        <Paper p="lg" radius="sm" shadow="md">
          <Stack>
            <Title fw={600} fz={24} order={1}>
              {error.name}
            </Title>

            <ScrollAreaAutosize mah={200}>
              <Text>{error.message}</Text>
            </ScrollAreaAutosize>

            {!!error.stack && (
              <>
                <Divider />
                <Text fz="xs">
                  In <Code>{error.fileName}</Code> at line {error.lineNumber}:{error.columnNumber}
                </Text>
                <Code block>
                  <ScrollAreaAutosize mah={300}>{error.stack}</ScrollAreaAutosize>
                </Code>
              </>
            )}
          </Stack>
        </Paper>
      </Container>
    </Center>
  );
}
